<div id="vehicle-label-container" *ngIf="vehicleInfo">
  <!-- un risultato -->
  <span class="mat-h2" *ngIf="vehicleInfo.versions.length == 1">
    Risultato trovato per la targa
    <span class="accent-color"> {{ vehicleInfo.vehiclePlate }} </span>: &nbsp;
    <span class="vehicle-versions" (click)="onVehicleVersionClick(vehicleInfo.versions[0])"> {{ vehicleInfo.versions[0].description }} </span>
  </span>
  <!-- più risultati -->
  <span class="mat-h2" *ngIf="vehicleInfo.versions.length > 1">
    Risultati trovati per la targa: <span class="accent-color">{{ vehicleInfo.vehiclePlate }} </span>
  </span>
</div>
